import React from "react"
import Link from "next/link"

export function HeroImage(props) {
  const {
    heroTitle,
    heroDescription,
    heroImageSrc,
    heroImageAlt,
    videoSrc,
    featuredTextOne,
    featuredLinkOne,
    featuredButtonTextOne,
    featuredTextTwo,
    featuredLinkTwo,
    featuredButtonTextTwo,
  } = props

  return (
    <div className="bg-gray-900">
      <div className="relative isolate h-screen overflow-hidden pt-14">
        <div className="absolute inset-0 -z-10 object-left-top">
          {videoSrc ? (
            <video autoPlay muted loop className="size-full object-cover">
              <source src={videoSrc} type="video/mp4" />
            </video>
          ) : (
            <img className="size-full object-cover" src={heroImageSrc} alt={heroImageAlt} />
          )}
        </div>

        <div className="mx-auto max-w-7xl px-6 lg:px-8">
          <div className="mx-auto pt-16 sm:pt-48 lg:max-w-2/3 lg:pt-56">
            <div className="text-center">
              <h1 className="font-mono text-4xl font-semibold tracking-tight text-balance text-white sm:text-7xl">
                {heroTitle}
              </h1>

              <p className="mt-8 font-mono text-lg font-medium text-pretty text-white sm:text-2xl">
                {heroDescription}
              </p>

              <div className="mt-8 grid grid-cols-1 items-center justify-center gap-4 gap-x-6 lg:grid-cols-2">
                <div class="col-span-1">
                  <div class="p-4 font-mono text-2xl text-white">{featuredTextOne}</div>
                  <Link
                    href={featuredLinkOne}
                    className="inline-flex items-center gap-x-1.5 rounded-full bg-white px-4 py-2 text-sm font-semibold"
                  >
                    {featuredButtonTextOne} <span aria-hidden="true">→</span>
                  </Link>
                </div>
                <div class="col-span-1">
                  <div class="p-4 font-mono text-2xl text-white">{featuredTextTwo}</div>
                  <Link
                    href={featuredLinkTwo}
                    className="inline-flex items-center gap-x-1.5 rounded-full bg-white px-4 py-2 text-sm font-semibold"
                  >
                    {featuredButtonTextTwo} <span aria-hidden="true">→</span>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
